module.exports = __webpack_public_path__ + "img/sksw2.c517a7c8.png";